import BaseBean from "@/utils/BaseBean";

export interface IViewFileDataObj {
    utilInst:ViewFileUtil
    refMap:Map<string,any>
    cxId:string
    brandId:string
    pageListRef:any
    fileUrl:string
    fileName:string
    moduleType:number
    pdfEngineParams:any
}

export default class ViewFileUtil extends BaseBean{
    public dataObj:IViewFileDataObj

    constructor(proxy:any,dataObj:IViewFileDataObj) {
        super(proxy);
        this.dataObj=dataObj;
    }
}